import { render, staticRenderFns } from "./Grant.vue?vue&type=template&id=57e4d416&scoped=true&"
import script from "./Grant.vue?vue&type=script&lang=js&"
export * from "./Grant.vue?vue&type=script&lang=js&"
import style0 from "./Grant.vue?vue&type=style&index=0&id=57e4d416&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e4d416",
  null
  
)

export default component.exports